import PropTypes from "prop-types"
import React, { createContext, useState } from "react"
import { useMarina } from "src/contexts/MarinaContext"

import ContractsForm from "./ContractsForm"

export const ContractsFormContext = createContext({
  namedRates: [],
  pricingUrl: "",
  editDocumentUrl: "",
  groupId: "",
  action: "",
  pricingStructures: {
    monthly: [],
  },
  longTermStorageProducts: [],
  documentRequirements: [],
  marinaAttachments: [],
  customFieldDefinitions: [],
  templates: [],
  m2mPercentBasedItemsEnabled: false,
  spaces: [],
  presentmentCurrency: "USD",
  useNewTaxExperience: false,
})

export const ContractsFormContextProvider = (props) => {
  const {
    namedRates,
    pricingUrl,
    rateOptions: { pricingStructures },
    longTermStorageProducts,
    documentRequirements,
    marinaAttachments,
    editDocumentUrl,
    customFieldDefinitions,
    groupId,
    action,
    templates = [],
    templatesPath,
    selectedTemplateId,
    withTemplate,
    currentUserEncodedId,
    spaces,
    isGroup,
    convenienceFeeCopy,
    useNewTaxExperience,
    ...contractsFormProps
  } = props

  const { presentmentCurrency } = useMarina()

  const [selectedTemplate, setSelectedTemplate] = useState(
    templates.find((template) => template.id === selectedTemplateId)
  )

  return (
    <ContractsFormContext.Provider
      value={{
        namedRates,
        pricingUrl,
        pricingStructures,
        longTermStorageProducts: longTermStorageProducts || [],
        documentRequirements: documentRequirements || [],
        marinaAttachments: marinaAttachments || [],
        editDocumentUrl,
        groupId,
        action,
        customFieldDefinitions: customFieldDefinitions || [],
        selectedTemplate,
        selectedTemplateId,
        setSelectedTemplate,
        templates,
        templatesPath,
        withTemplate,
        currentUserEncodedId,
        spaces,
        isGroup,
        convenienceFeeCopy,
        convenienceFeeRemovedButEnabled:
          !convenienceFeeCopy && !!contractsFormProps.form?.applyConvenienceFee,
        presentmentCurrency,
        useNewTaxExperience,
      }}
    >
      <ContractsForm {...contractsFormProps} />
    </ContractsFormContext.Provider>
  )
}

ContractsFormContextProvider.propTypes = {
  namedRates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      amount: PropTypes.number,
      taxRate: PropTypes.number,
    })
  ).isRequired,
  pricingUrl: PropTypes.string.isRequired,
  groupId: PropTypes.string,
  editDocumentUrl: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  rateOptions: PropTypes.shape({
    pricingStructures: PropTypes.shape({
      monthly: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        })
      ).isRequired,
      full_stay: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        })
      ).isRequired,
    }).isRequired,
  }).isRequired,
  longTermStorageProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      combinedTaxRateDisplay: PropTypes.string,
      taxes: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          rateDisplay: PropTypes.string.isRequired,
        })
      ),
    }).isRequired
  ).isRequired,
  documentRequirements: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  marinaAttachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  customFieldDefinitions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      previewImageUrl: PropTypes.string.isRequired,
      updatedAt: PropTypes.string,
    })
  ),
  templatesPath: PropTypes.string.isRequired,
  selectedTemplateId: PropTypes.string,
  withTemplate: PropTypes.bool,
  currentUserEncodedId: PropTypes.string.isRequired,
  spaces: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  selectedSpaceId: PropTypes.string,
  isGroup: PropTypes.bool,
  convenienceFeeCopy: PropTypes.string,
  useNewTaxExperience: PropTypes.bool,
}

export default ContractsFormContextProvider
